import { Field } from 'react-final-form'
import moment from 'moment'

import Badge from 'common/components/Badge'
import ContentTypeBubble from 'common/components/ContentTypeBubble'
import DatePicker from 'common/components/datePicker/DatePicker'
import FormItem from 'common/components/FormItem'
import Input from 'common/components/Input'
import SingleSelect, { SelectValue } from 'common/components/singleSelect'
import useProjectsQuery from 'features/campaigns/queries/useProjectsQuery'

import { useExperimentForm } from './context/ExperimentFormContext'

import './DatePickerStyles.css'

const validateName = (value: string | undefined) => {
  if (!value?.trim()) {
    return 'Enter a name for your experiment.'
  }
}
const validateProject = (value: SelectValue) => {
  if (!value) {
    return 'Select your project.'
  }
}

const SetUpExperiment = () => {
  const {
    state: { template },
  } = useExperimentForm()

  const { data: projects } = useProjectsQuery()
  const projectOptions = projects?.map((project) => ({
    label: project.name,
    value: project._id,
  }))

  return (
    <div className="SetUpExperiment bg-white p-6 flex flex-col w-full">
      <div className="flex items-center mb-4">
        <ContentTypeBubble
          name={template?.displayName}
          iconType={template?.icon || ''}
        />
        <div className="text-base font-medium flex ml-4 text-coolGray-800">
          {template?.displayName}
        </div>
        <Badge
          text="Optimize"
          variant="optimize"
          size="small"
          className="capitalize ml-auto"
        />
      </div>
      <Field<string> name="experimentName" validate={validateName}>
        {({ input, meta }) => (
          <FormItem
            error={meta.touched ? meta.error : undefined}
            label="Experiment name"
            className="flex-none mb-4"
          >
            <Input
              data-cy="experiment-name-input"
              type="text"
              variant="default"
              className="w-full focus:bg-orange-50"
              value={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
              id="experimentName"
              name="experimentName"
              placeholder="Give your experiment a memorable name"
            />
          </FormItem>
        )}
      </Field>
      <div className="flex justify-between gap-4">
        <Field<SelectValue> name="project" validate={validateProject}>
          {({ input, meta }) => (
            <FormItem
              label="Project"
              htmlFor="project"
              error={meta.touched ? meta.error : undefined}
              className="w-full"
            >
              <SingleSelect
                className="w-full"
                data-cy="project-select"
                name="project"
                placeholder="Select your project"
                value={input.value.value}
                onChange={input.onChange}
                onBlur={input.onBlur}
                options={projectOptions}
                menuPortalTarget={document.body}
              />
            </FormItem>
          )}
        </Field>
        <Field<string> name="sendDate">
          {({ input, meta }) => (
            <FormItem
              label="Send date"
              htmlFor="sendDate"
              error={meta.touched ? meta.error : undefined}
              className="w-full"
            >
              <DatePicker
                date={moment()}
                onDateChange={() => {}}
                id="sendDate"
                disabled={false}
                isOutsideRange={() => false}
                numberOfMonths={1}
              />
            </FormItem>
          )}
        </Field>
      </div>
      <Field<string> name="controlSubjectLine" validate={validateName}>
        {({ input, meta }) => (
          <FormItem
            error={meta.touched ? meta.error : undefined}
            label="Control subject line"
            className="flex-none mb-4"
          >
            <Input
              data-cy="control-subject-line-input"
              type="text"
              variant="default"
              className="w-full focus:bg-orange-50"
              value={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
              id="controlSubjectLine"
              name="controlSubjectLine"
              placeholder="Enter your control"
            />
          </FormItem>
        )}
      </Field>
    </div>
  )
}

export default SetUpExperiment
